import OtpConfirmation from "./OtpConfirmation";

export default OtpConfirmation;